'use client';

import { motion, type HTMLMotionProps } from 'motion/react';

import { Slot, type WithAsChild } from '../animate/slot';

type ButtonProps = WithAsChild<
  Omit<HTMLMotionProps<'button'>, 'ref'> & {
    ref?: React.Ref<HTMLButtonElement>;
    hoverScale?: number;
    tapScale?: number;
  }
>;

function Button({
  hoverScale = 1.05,
  tapScale = 0.95,
  asChild = false,
  ref,
  ...props
}: ButtonProps) {
  const Component = asChild ? Slot : motion.button;

  const enableHover = typeof hoverScale === 'number' && hoverScale !== 1;
  const enableTap = typeof tapScale === 'number' && tapScale !== 1;

  return (
    <Component
      ref={ref}
      whileTap={enableTap ? { scale: tapScale } : undefined}
      whileHover={enableHover ? { scale: hoverScale } : undefined}
      {...props}
    />
  );
}

export { Button, type ButtonProps };
